import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'components/base';
import Button from 'components/base/button';
import QrCode from 'react-qr-code'
import SETTINGS from '../settings';
import uploadSessionsApi from '../api/upload-sessions';
import store from 'utils/store';

const SESSION_STORAGE_ID_KEY = "upload-session-id"
const SESSION_STORAGE_PHOTOS_KEY = "upload-session-photos"

const UppyQrComponent = props => {
  const [id, setId] = useState(null)

  const [initPhotos, setInitPhotos] = useState(JSON.parse(store.session.get(SESSION_STORAGE_PHOTOS_KEY, "[]")));
  const [photos, setPhotos] = useState(initPhotos);
  useEffect(() => {
    store.session.set(SESSION_STORAGE_PHOTOS_KEY, JSON.stringify(photos))
  }, [photos])

  const intervalRef = useRef()

  useEffect(() => {
    (async () => {
      let needNewSession = true;

      const sessionId = store.session.get(SESSION_STORAGE_ID_KEY)
      if (sessionId) {
        const { data, error } = await uploadSessionsApi().getData(sessionId)
        if (data) {
          setId(sessionId)
          setPhotos(val => {
            const allPhotos = data.urls.filter(photo => typeof photo === "object")
            const newPhotos = allPhotos.filter(photo => !val.find(p => p.url === photo.url))
            props.onUpload(newPhotos)
            return allPhotos
          })
          needNewSession = false
        }
      }

      if (needNewSession) {
        const { data } = await uploadSessionsApi(props.paraboAccessToken).create();
        if (data) {
          store.session.set(SESSION_STORAGE_ID_KEY, data.session_id)
          setId(data.session_id)
          setInitPhotos([])
          setPhotos([])
        }
      }
    })()

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [])

  useEffect(() => {
    if (id) {
      intervalRef.current = setInterval(async () => {
        let body;

        const element = document.getElementById("uppy-DashboardContent-panel--qr");
        if (element) {
          body = element.getElementsByClassName("uppy-DashboardContent-panelBody")[0];
        }


        if (body) {
          const { data } = await uploadSessionsApi().getData(id)
          if (data) {
            setPhotos(val => {
              const allPhotos = data.urls.filter(photo => typeof photo === "object")
              const newPhotos = allPhotos.filter(photo => !val.find(p => p.url === photo.url))
              props.onUpload(newPhotos)
              return allPhotos
            })
          }
        } else {
          clearInterval(intervalRef.current)
        }
      }, 3000)
    }

    return () => {
      clearInterval(intervalRef.current)
    }
  }, [id])

  const getLabel = (val) => {
    if (val <= 0) {
      return "Waiting for photos"
    }
    if (val === 1) {
      return "1 photo uploaded"
    }
    return `${val} photos uploaded`
  }

  const url = `${SETTINGS.HOST}/media/${id}?max=${props.maxNumberOfFiles}`

  return (
    <div className='text-center'>
      {id ? <>
        <h1>Scan this QR code on your mobile device</h1>
        <br />
        <a href={url} target='_blank'>
          <QrCode value={url} />
        </a>
        <br /><br />
        <h1>{getLabel(photos.length - initPhotos.length)}</h1>
        <br />
        <Button type="primary" onClick={props.onDone}>Done</Button>
      </> : <Spinner />
      }
    </div>
  );
};

export default UppyQrComponent;
